import React, { useMemo, useState } from 'react';
import SubscriberPayerForm from './subscriber-payer-form';
import * as S from '../../claim-editor.styles';
import { ClaimEditorStore } from '../../../../stores/claim-editor';
import * as CS from '../section.styles';
import { BaseButton } from '../../../base/button';

interface ISubscriberPayerListProps {
    initialItems?: any[];
    claimEditorStore: ClaimEditorStore;
}

export const SubscriberPayerList: React.FunctionComponent<ISubscriberPayerListProps> = ({ initialItems, claimEditorStore }) => {
    const initial = useMemo<any[]>(() => {
        const fromStore = claimEditorStore.subscribers;
        if (fromStore && Array.isArray(fromStore) && fromStore.length) return fromStore;
        return initialItems ?? [];
    }, [initialItems]);
    const [items, setItems] = useState<any[]>(initial);

    const handleAdd = (): void => {
        setItems(prev => {
            const next = prev.length >= 3 ? prev : [...prev, {}];
            claimEditorStore.updateSubscribers(next as any);
            return next;
        });
    };

    const handleRemove = (index: number): void => {
        setItems(prev => {
            const next = prev.filter((_, i) => i !== index);
            claimEditorStore.updateSubscribers(next as any);
            return next;
        });
    };


    return (
        <div>
            {items.map((item, idx) => (
                <CS.SectionContainer key={idx}>
                    <CS.SectionHeader>
                        <CS.SectionTitle>{idx === 0 ? 'Primary' : idx === 1 ? 'Secondary' : 'Tertiary'}</CS.SectionTitle>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <BaseButton
                                variant="outlined"
                                onClick={(): void => {
                                    claimEditorStore.copySubscriberFromPatient(idx);
                                    const subs = claimEditorStore.subscribers || [];
                                    const updated = subs[idx] || {};
                                    setItems(prev => {
                                        const next = [...prev];
                                        next[idx] = updated;
                                        return next;
                                    });
                                }}
                            >
                                Copy From Patient
                            </BaseButton>
                            <BaseButton variant="warning" onClick={(): void => handleRemove(idx)}>✕ Remove Subscriber</BaseButton>
                        </div>
                    </CS.SectionHeader>
                        <SubscriberPayerForm claimEditorStore={claimEditorStore} data={item} subscriberIndex={idx} />
                </CS.SectionContainer>
            ))}

            <CS.ButtonContainer>
                <BaseButton variant="primary" onClick={handleAdd} disabled={items.length >= 3}>+ Add Subscriber</BaseButton>
            </CS.ButtonContainer>
        </div>
    );
};

export default SubscriberPayerList;


